import { Outlet, Route, Routes } from 'react-router-dom';

import { AuthViewLogin, AuthViewLogout } from 'pages/auth/auth.pages';

import {
  LandingPage,
  CareCollectionsRoutes,
  CareDiscoveryRoutes,
  HealthNeedPages,
  HealthProfileRoutes,
  Home,
  AboutMyHealthAlbertaPage,
} from 'components/routes/lazy-routes.component';
import { AchievementsRouteElement } from 'components/routes/achievements-route-element.component';
import { HealthJourneyRoutes } from '@leagueplatform/health-journey';
import { LiveChatRoutes } from '@leagueplatform/live-chat';
import { BasePathRedirect } from '@telus-alberta-health-web/shared-module';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import ErrorPage from 'pages/error-404.page';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { CareServicesPage } from 'pages/care-services/care-services.page';
import { PrivacyPolicyInAppPage } from 'pages/privacy-policy/privacy-policy-in-app.page';
import { BrowseHealthTopics } from 'pages/health-topics/health-topics.page';
import { NotificationsPage } from 'pages/settings/notifications/notifications.page';
import { PersonalInformationPage } from 'pages/settings/personal-information/personal-information.page';
import { FindSupportPage } from 'pages/find-support/find-support.page';
import { ChatPage } from 'pages/chat/chat.page';
import { AboutMeRoutesWithoutTabs } from 'components/about-me/about-me-routes-without-tabs.component';
import { AuthSessionContainer } from '../auth-session-container/auth-session-container';

function AppRoutes() {
  return (
    <Routes>
      <Route
        path={`${APP_MANAGED_ROUTES.SIGN_IN}/*`}
        element={<AuthViewLogin />}
      />
      <Route
        path={`${APP_MANAGED_ROUTES.SIGN_OUT}/*`}
        element={<AuthViewLogout />}
      />
      <Route path={APP_MANAGED_ROUTES.LANDING_PAGE} element={<LandingPage />} />
      <Route path={`${APP_MANAGED_ROUTES.CHAT}/*`} element={<ChatPage />} />
      <Route
        element={
          <AuthSessionContainer>
            <Outlet />
          </AuthSessionContainer>
        }
      >
        <Route
          path={`${APP_MANAGED_ROUTES.MEMBER_REDIRECT}/*`}
          element={<BasePathRedirect targetBasePath="" />}
        />
        <Route path={APP_MANAGED_ROUTES.HOME} element={<Home />} />
        <Route
          path={APP_MANAGED_ROUTES.ABOUT_MY_HEALTH_ALBERTA}
          element={<AboutMyHealthAlbertaPage />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/*`}
          element={<HealthJourneyRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthPrograms)}/*`}
          element={<HealthJourneyRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthProgress)}/*`}
          element={<HealthJourneyRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthJourneyHistory)}/*`}
          element={<HealthJourneyRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.careLibrary)}/*`}
          element={<HealthJourneyRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.careCollections)}/*`}
          element={<CareCollectionsRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.careDiscovery)}/*`}
          element={<CareDiscoveryRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.rewardsAchievements)}/*`}
          element={<AchievementsRouteElement />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.liveChat)}/*`}
          element={<LiveChatRoutes />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.HEALTH_TOPICS}/*`}
          element={<BrowseHealthTopics />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.AUTHENTICATED_CARE_SERVICES}/*`}
          element={<CareServicesPage />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.UNAUTHENTICATED_CARE_SERVICES}/*`}
          element={<CareServicesPage />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.PRIVACY_POLICY}/*`}
          element={<PrivacyPolicyInAppPage />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthNeedPages)}/*`}
          element={<HealthNeedPages />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthProfile)}/*`}
          element={<HealthProfileRoutes />}
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.aboutMe)}/*`}
          element={<AboutMeRoutesWithoutTabs />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.NOTIFICATIONS}/*`}
          element={<NotificationsPage />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.PERSONAL_INFO}/*`}
          element={<PersonalInformationPage />}
        />
        <Route
          path={`${APP_MANAGED_ROUTES.FIND_SUPPORT}/*`}
          element={<FindSupportPage />}
        />
        <Route element={<ErrorPage />} path="/*" />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
